import { PerformedByRequestDTO } from './performed-by-request-dto';

export interface ReadUserContextRoleProfileAccessDetailsRequestDTO extends PerformedByRequestDTO {
    userRoleContextProfileId?: number;
    languageCd?: string;
}
